import { lazy } from 'react';
const FabcInquiry = lazy(() => import('./FabcInquiry'));

const FabcInquiryRoutes = [
  {
    path: '/fabcInquiry',
    component: FabcInquiry
  }
];

export default FabcInquiryRoutes;
